import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api, API } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";

export default function Manuals() {
  const { mode, brand } = useBrand();
  const [manuals, setManuals] = useState([]);
  const [brandsMap, setBrandsMap] = useState({});

  useEffect(() => {
    const load = async () => {
      const params = new URLSearchParams();
      if (mode === "brand" && brand) params.set("brand_slug", brand.slug);
      const [ms, brs] = await Promise.all([
        api.get(`/manuals?${params.toString()}`).then((r) => r.data),
        api.get(`/brands`).then((r) => r.data),
      ]);
      setManuals(ms);
      const m = {};
      brs.forEach((b) => (m[b.id] = b));
      setBrandsMap(m);
    };
    load();
  }, [mode, brand]);

  const download = async (m) => {
    const { data } = await api.get(`/manuals/${m.id}`);
    if (!data.pdf_data) return;
    const a = document.createElement("a");
    a.href = data.pdf_data;
    a.download = `${m.title}.pdf`;
    a.click();
  };

  return (
    <div className="fade-in-up" data-testid="manuals-page">
      <SEO title="Kullanım Kılavuzları" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Dökümanlar</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Kullanım Kılavuzları</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {manuals.length === 0 ? (
          <div className="text-center py-20 text-zinc-500" data-testid="manuals-empty">
            Henüz kullanım kılavuzu bulunmuyor.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="manuals-grid">
            {manuals.map((m) => (
              <button
                key={m.id}
                onClick={() => download(m)}
                className="text-left border border-white/10 bg-[#0A0A0A] p-5 flex items-center gap-4 hover:border-white/30 transition-colors group"
                data-testid={`manual-${m.id}`}
              >
                <div className="w-12 h-12 border border-white/10 flex items-center justify-center shrink-0">
                  <FileText size={20} className="text-zinc-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{m.title}</div>
                  <div className="text-xs text-zinc-500 mt-1 uppercase tracking-[0.15em]">
                    {brandsMap[m.brand_id]?.name || "PDF"}
                  </div>
                </div>
                <Download size={16} className="text-zinc-500 group-hover:text-white shrink-0" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
